// ** Style Imports
import "./App.css";

// ** Custom Component Imports
import HomePage from "./pages/HomePage";

// ** Routes imports
import {BrowserRouter, Route, Routes} from "react-router-dom";
import DefaultLayouts from "./layouts/DefaultLayouts";

function App() {
  return (
    <div className="overflow-x-hidden">
      <BrowserRouter>
          <Routes>
              <Route path="/*" Component={DefaultLayouts}></Route>
          </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
